<template>
  <div class="user_body">
    <span class="title">需求咨询</span>
    <div class="user_item2">
      <span>*</span>
      <span>标题：</span>
      <el-input v-model="title" placeholder="请输入咨询标题" class="input_size" size="small"></el-input>
    </div>

    <div class="user_item2">
      <span>*</span>
      <span>内容详情：</span>
      <el-input v-model="content" placeholder="请输入咨询内容" class="input_size" type="textarea" rows="9"></el-input>
    </div>

    <div class="user_item2">
      <span>*</span>
      <span>相关图片：</span>
      <!-- <el-upload action="#" list-type="picture-card" :auto-upload="false">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt>
          <span class="el-upload-list__item-actions">
            <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </el-upload> -->
      <el-upload action="#" :auto-upload="false" :file-list="imageFileList" list-type="picture-card" :on-remove="handleRemove"
        :on-change="handleUploadChange">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>

    <div class="user_item4">
      <span>*</span>
      <span>相关附件：</span>
      <el-upload class="upload-demo" action="#" :auto-upload="false" :on-change="handleChange" :file-list="attachmentFileList" :limit="1">
        <div class="up_load">+ 点击上传</div>
      </el-upload>
    </div>
    <div class="user_item">
      <span></span>
      <span class="btns" @click="handleSubmit">确认提交</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "UserInfoView",
  data() {
    return {
      images: [],
      imageFileList: [],
      attachment: '',
      attachmentFileList: [],
      title: '',
      content: '',
      isLoading: false
    };
  },
  mounted() { },
  methods: {
    handleUploadChange(file, fileList) {
    
      this.$api.upload({
        file: file.raw
      }).then(res => {
        if (res.code === 1) {
          this.images.push(res.data.fullurl);
         
        }else{
          this.$message.error(res.message);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('上传失败');
      });
    },
    handleChange(file, fileList) {
      this.$api.upload({
        file: file.raw
      }).then(res => {
        if (res.code === 1) {
          this.attachment = res.data.fullurl;
        }else{
          this.$message.error(res.message);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('上传失败');
      });
    },
    handleRemove(file,fileList) {
      // 移除图片
      const index = this.images.findIndex(item => item.uid === file.uid)
      if (index !== -1) {
        this.images.splice(index, 1)
        this.imageFileList = fileList
      }
    },
    async handleSubmit() {
      if (!this.title) {
        this.$message.error('请输入咨询标题');
        return;
      }
      if (!this.content) {
        this.$message.error('请输入咨询内容');
        return;
      }
      if (!this.images.length) {
        this.$message.error('请上传相关图片');
        return;
      }
      if (!this.attachment) {
        this.$message.error('请上传相关附件');
        return;
      }
      this.isLoading = true;
      try {
        const res = await this.$api.addConsultation({
          title: this.title,
          content: this.content,
          images: this.images,  
          attachment: this.attachment
        }).then(res => {
          if (res.code === 1) {
            this.$message.success('提交成功');
            this.$router.push('/MyOrderListView?type=2');
          }else{
            this.$message.error(res.message);
          }
        }).catch(err => {
          this.$message.error('提交失败');
          console.log(err);
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}

.title {
  color: #666666;
  font-size: 16px;
}

.user_item2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 15px;
}

.user_item2 span:nth-child(odd) {
  font-size: 14px;
  color: red;
  text-align: left;
  width: 10px;
}

.user_item2 span:nth-child(even) {
  width: 70px;
  font-size: 14px;
  color: #999999;
  text-align: left;
}

.user_item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
}

.user_item span:nth-child(odd) {
  width: 80px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}

.user_item3 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
}

.user_item3 span:nth-child(odd) {
  width: 80px;
  font-size: 14px;
  color: #999999;
}

.text1 {
  font-size: 14px;
  color: #999999;
}

.text2 {
  font-size: 14px;
  color: #3c9c8f;
}

.user_icon {
  width: 70px;
  height: 70px;
  border-radius: 70px;
}

.input_size {
  width: 300px;
}

.btns {
  width: 160px;
  height: 40px;
  color: #ffffff;
  background: #3c9c8f;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  margin-top: 20px;
}

.up_load {
  border: 1px solid #3C9C8F;
  color: #3C9C8F;
  font-size: 14px;
  width: 110px;
  height: 30px;
  line-height: 30px;
}

.user_item4 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
}

.user_item4 span:nth-child(odd) {
  font-size: 14px;
  color: red;
  text-align: left;
  width: 10px;
}

.user_item4 span:nth-child(even) {
  width: 70px;
  font-size: 14px;
  color: #999999;
  text-align: left;
}
</style>
